import React from 'react';

import iconCircleManWithThumbsUp from '@assets/icons/circle-man-with-thumbs-up.png';
import { ModalBasic, ModalBasicProps } from '@shared/ui/modal/ModalBasic';
import { ModalBodyGratitudeOnline } from './bodies/ModalBodyGratitudeOnline';
import { useGetIconOptimized } from '@shared/hooks/useGetIconOptimized';

type ModalGratitudeOnlineProps = Pick<ModalBasicProps, 'isVisible' | 'onClose' | 'onApprove'> & {
  bonus?: number;
  variant?: 'for-members' | 'for-guests';
};

export const ModalGratitudeOnline: React.FC<ModalGratitudeOnlineProps> = ({
  isVisible,
  onClose,
  onApprove,
  variant = 'for-members',
  bonus = 0,
}) => {
  const iconOptimized = useGetIconOptimized('circle-man-with-thumbs-up');
  const imageHeading = {
    optimized: iconOptimized,
  };

  return (
    <ModalBasic
      isVisible={isVisible}
      title="thanks-help-on-the-way"
      imageHeading={imageHeading}
      approveBtnLabel={variant === 'for-members' ? 'go' : 'join-edopomoga-team'}
      secondaryBtnLabel={variant === 'for-members' ? 'stay' : 'help-without-registration'}
      onClose={onClose}
      onApprove={onApprove}
    >
      <ModalBodyGratitudeOnline variant={variant} bonus={bonus} />
    </ModalBasic>
  );
};
